import {Form, Select} from 'antd';
import SubmitButton from 'components/Startup/components/SubmitButton';
import {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate, useParams} from 'react-router-dom';
import {listType} from 'redux/store/campaign';
import styles from './listingType.module.scss';
import {toast} from 'react-toastify';
import StageHeader from 'pages/campaigns/new/components/StageHeader';
import ErrorSummary from 'pages/campaigns/new/components/ErrorSummary';
import FieldError from 'pages/campaigns/new/components/FieldError';
import {useStageValidation} from 'pages/campaigns/new/components/useStageValidation';

const ListingType = () => {
  const [listingType, setListingType] = useState('');
  const [listingMode, setListingMode] = useState('');
  const {errors, validate} = useStageValidation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {slug, id, companyId} = useParams();

  const campaign = useSelector(state => state.campaign.campaign);

  useEffect(() => {
    setListingType(campaign?.listType);
    setListingMode(campaign?.listMode);
  }, [campaign?.listType, campaign?.listMode]);

  const handleSubmit = () => {
    const rules = [
      {
        field: 'listMode',
        valid: !!listingMode,
        message: 'List Mode is required',
      },
      {
        field: 'listType',
        valid: !!listingType,
        message: 'List Type is required',
      },
    ];
    if (!validate(rules)) return;
    if (listingType === 'IPO' && listingMode === 'TEST') {
      return toast.error('Cannot create a Test IPO');
    }
    dispatch(
      listType({
        listType: listingType,
        listMode: listingMode,
      }),
    );
    if (slug) {
      navigate(`/dashboard/campaigns/${slug}/new/${id}/${companyId}`);
    } else {
      navigate(`/dashboard/campaigns/new/${id}/${companyId}`);
    }
  };

  return (
    <div className={styles.container}>
      <StageHeader
        title="List Type"
        description="Choose whether this is a live or test listing and its listing type."
      />
      <ErrorSummary fields={Object.values(errors)} />
      <Form layout="vertical" onFinish={handleSubmit}>
        <Form.Item label="List Mode" required className={styles['field-item']}>
          <Select
            placeholder="Please select a listing mode"
            value={listingMode || undefined}
            onChange={e => setListingMode(e)}>
            <Select.Option value="TEST">TEST</Select.Option>
            <Select.Option value="LIVE">LIVE</Select.Option>
          </Select>
          <FieldError message={errors.listMode} />
        </Form.Item>
        <Form.Item label="List Type" required className={styles['field-item']}>
          <Select
            placeholder="Please select a listing type"
            value={listingType || undefined}
            onChange={e => setListingType(e)}>
            {listingMode === 'LIVE' && (
              <Select.Option value="IPO">IPO</Select.Option>
            )}
            <Select.Option value="VENTURE">Venture</Select.Option>
            <Select.Option value="VENTURE_FUND">Venture Fund</Select.Option>
          </Select>
          <FieldError message={errors.listType} />
        </Form.Item>
        <SubmitButton label="Save Changes" />
      </Form>
    </div>
  );
};

export default ListingType;
